import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

type ElementListTreeProps = {
  /** Accessible name of the tree (Elements, Products, Actions, …). */
  'aria-label': string;
  children: ReactNode;
};

/**
 * Parent of {@link ElementListRow} `treeitem`s. Rows are a flat DOM list with
 * `aria-level` for nesting, so they need one tree ancestor rather than nested lists.
 */
export const ElementListTree: React.FC<ElementListTreeProps> = ({
  'aria-label': ariaLabel,
  children,
}) => (
  <Box role="tree" aria-label={ariaLabel}>
    {children}
  </Box>
);
